import { Alert, CloseButton } from '@heroui/react';

// Η ειδοποίηση της εφαρμογής, με τις προεπιλογές δεμένες μία φορά εδώ.
//
// Το `<Alert>` του HeroUI, χρησιμοποιημένο σκέτο, δίνει λευκό φόντο και **κανένα
// εικονίδιο**: η κατάσταση περνά μόνο από το χρώμα του τίτλου. Τα τέσσερα
// σήματα — απαλό φόντο ανά κατάσταση, σκούρο κείμενο, εικονίδιο, αριστερό
// περίγραμμα στο έντονο χρώμα — ορίζονται στο `index.css` και εδώ, ώστε να μη
// χρειάζεται να θυμηθεί κανείς να συνθέσει τα τέσσερα υποσυστατικά σε κάθε οθόνη.
//
// **Πότε κλείνει και πότε όχι.** Το κουμπί κλεισίματος εμφανίζεται μόνο όταν
// δοθεί `onDismiss`, και ο κανόνας δεν είναι αισθητικός:
//
// - **Κλείνουν** τα μηνύματα επιτυχίας και ενημέρωσης. Ο χρήστης τα διάβασε, η
//   ενέργεια ολοκληρώθηκε, και το μήνυμα καταλαμβάνει χώρο χωρίς λόγο.
// - **Δεν κλείνουν** τα σφάλματα επικύρωσης και οι απορρίψεις. Το μήνυμα είναι ο
//   λόγος για τον οποίο η φόρμα δεν προχώρησε· αν φύγει, ο χρήστης μένει με μια
//   φόρμα που δεν υποβάλλεται και κανένα στοιχείο για το γιατί. Φεύγει μόνο όταν
//   διορθωθεί η αιτία.

/**
 * @param status   'accent' (ενημέρωση) | 'success' | 'warning' | 'danger'
 * @param title    Ο τίτλος. Υποχρεωτικός: μια ειδοποίηση χωρίς τίτλο είναι κείμενο.
 * @param onDismiss Αν δοθεί, εμφανίζεται κουμπί κλεισίματος 24×24.
 */
export function Notice({ status = 'accent', title, onDismiss, children, className = '', ...rest }) {
    return (
        <Alert status={status} className={className} {...rest}>
            <Alert.Indicator />
            <Alert.Content>
                <Alert.Title>{title}</Alert.Title>
                {children && <Alert.Description>{children}</Alert.Description>}
            </Alert.Content>
            {onDismiss && (
                <CloseButton
                    aria-label={`Κλείσιμο της ειδοποίησης: ${title}`}
                    onPress={onDismiss}
                    className="ms-auto shrink-0"
                />
            )}
        </Alert>
    );
}

export default Notice;
